var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9231 0C46.4737 0 47.7308 1.25705 47.7308 2.80769C47.7308 4.24758 46.6469 5.43431 45.2505 5.5965L44.9231 5.61539L5.61539 5.61539L5.61539 67.3846L67.3846 67.3846L67.3846 5.61539C65.9447 5.61539 64.758 4.5315 64.5958 3.13513L64.5769 2.80769C64.5769 1.36781 65.6608 0.181076 67.0572 0.0188894L67.3846 0L70.1923 0C71.6322 0 72.8189 1.08388 72.9811 2.48026L73 2.80769L73 70.1923C73 71.6322 71.9161 72.8189 70.5197 72.9811L70.1923 73L2.80769 73C1.36781 73 0.181076 71.9161 0.0188894 70.5197L0 70.1923L0 2.80769C0 1.36781 1.08388 0.181076 2.48026 0.0188894L2.80769 0L44.9231 0Z",
    transform: "translate(8 9)",
    id: "Path",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 0L65 6L0 6L0 0L65 0Z",
    transform: "translate(14 42)",
    id: "Path-26",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0L6 68L0 68L0 0L6 0Z",
    transform: "translate(42 11)",
    id: "Path-27",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.09378 5.97982 2.50291L6 2.83333L6 14.1667C6 15.7315 4.65685 17 3 17C1.46149 17 0.193479 15.9062 0.0201832 14.4971L0 14.1667L0 2.83333C0 1.26853 1.34315 0 3 0Z",
    transform: "translate(25 20)",
    id: "Path-28",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 0C4.25485 0 5.44361 1.08574 5.60608 2.4845L5.625 2.8125L5.625 14.0625C5.625 15.6158 4.3658 16.875 2.8125 16.875C1.37015 16.875 0.181386 15.7893 0.0189217 14.3905L0 14.0625L0 2.8125C0 1.2592 1.2592 0 2.8125 0Z",
    transform: "matrix(0.70710677 0.70710677 -0.70710677 0.70710677 65.85248 53.920048)",
    id: "Path-28",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 0C4.25485 0 5.44361 1.08574 5.60608 2.4845L5.625 2.8125L5.625 14.0625C5.625 15.6158 4.3658 16.875 2.8125 16.875C1.37015 16.875 0.181386 15.7893 0.0189217 14.3905L0 14.0625L0 2.8125C0 1.2592 1.2592 0 2.8125 0Z",
    transform: "matrix(0.70710677 -0.70710677 0.70710677 0.70710677 53.920048 57.897526)",
    id: "Path-28",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.09378 5.97982 2.50291L6 2.83333L6 14.1667C6 15.7315 4.65685 17 3 17C1.46149 17 0.193479 15.9062 0.0201832 14.4971L0 14.1667L0 2.83333C0 1.26853 1.34315 0 3 0Z",
    transform: "matrix(-4.371139E-08 -1 1 -4.371139E-08 19.5 31.5)",
    id: "Path-28",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.09378 5.97982 2.50291L6 2.83333L6 14.1667C6 15.7315 4.65685 17 3 17C1.46149 17 0.193479 15.9062 0.0201832 14.4971L0 14.1667L0 2.83333C0 1.26853 1.34315 0 3 0Z",
    transform: "matrix(-4.371139E-08 -1 1 -4.371139E-08 53.5 31.5)",
    id: "Path-28-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 0C4.25485 0 5.44361 1.08574 5.60608 2.4845L5.625 2.8125L5.625 14.0625C5.625 15.6158 4.3658 16.875 2.8125 16.875C1.37015 16.875 0.181386 15.7893 0.0189217 14.3905L0 14.0625L0 2.8125C0 1.2592 1.2592 0 2.8125 0Z",
    transform: "matrix(-0.7071067 -0.7071068 -0.7071068 0.7071067 36.079952 57.897526)",
    id: "Path-28-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "matrix(-1 0 0 1 25 53)",
    id: "Oval",
    fill: "#0B67B2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "matrix(-1 0 0 1 37 65)",
    id: "Oval",
    fill: "#0B67B2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(62 8)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.790368d8ec6bead7130c775664acd390.svg";
export { ForwardRef as ReactComponent };